import { render, staticRenderFns } from "./Ranking-piechart.vue?vue&type=template&id=43333da2&scoped=true"
import script from "./Ranking-piechart.vue?vue&type=script&lang=js"
export * from "./Ranking-piechart.vue?vue&type=script&lang=js"
import style0 from "./Ranking-piechart.vue?vue&type=style&index=0&id=43333da2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43333da2",
  null
  
)

export default component.exports